__turbopack_context__.v({
  "actions": "styles-module-scss-module__pxTeAG__actions",
  "body": "styles-module-scss-module__pxTeAG__body",
  "contactCard": "styles-module-scss-module__pxTeAG__contactCard",
  "content": "styles-module-scss-module__pxTeAG__content",
  "heading": "styles-module-scss-module__pxTeAG__heading",
  "image": "styles-module-scss-module__pxTeAG__image",
  "imageWrapper": "styles-module-scss-module__pxTeAG__imageWrapper",
});
